import React, { useMemo } from 'react';
import { Field } from 'formik';
import { Grid, TextField } from '@material-ui/core';
import { SERVICES_CODES } from 'app/config/services';
import CustomDateField from '../../../../internalPages/Lines/components/DateField';
import moment from 'moment';

const LineDetails = props => {
  // Simular recebimento de configuração de tela
  const { cdServico, permissionaryData } = props;
  const serviceTime = useMemo(() => {
    if(permissionaryData?.dtInicioVigencia){
      const today = moment();
      const diff = moment(today).diff(permissionaryData.dtInicioVigencia);
      const duration = moment.duration(diff, 'milliseconds');
      const years = Math.round(duration.asDays() / 365);
      return `${years} ano(s)`;
    }
    return '';
  },[permissionaryData]);

  return (
    <Grid item container spacing={3}>
      <Grid item xs={12} sm={3}>
        <Field
          component={CustomDateField}
          label="Data de vencimento CEPE"
          name=''
          value={permissionaryData?.cepe?.dtVencimentoCrc || permissionaryData?.dtVencimento || null}
          disabled
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <Field
          component={CustomDateField}
          label="Data de solicitação"
          name='dtCadastro'
          disabled
          margin="dense"
        />
      </Grid>
      {cdServico !== SERVICES_CODES.SLIC_PRORROGACAO_PRAZO && (
        <Grid item xs={12} sm={3}>
          <TextField
            name=""
            label="Tempo de serviço na linha"
            margin="dense"
            variant="filled"
            fullWidth
            disabled
            value={serviceTime}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
      )}
      <Grid item xs={12} sm={3}>
        <TextField
          name=""
          label="Nº termo permissão"
          margin="dense"
          variant="filled"
          fullWidth
          disabled
          value={permissionaryData?.nuTermo}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
    </Grid>
  );
};

export default LineDetails;
